export enum ViewMode {
  EDIT,
  NEW,
}
